import AutoGrowTextarea from '../AutoGrowTextarea';

const BTN_COLORS = [
    { key: 'default', label: 'P', title: 'Padrão',    hex: '#6b7280' },
    { key: 'blue',    label: 'A', title: 'Azul',      hex: '#3b82f6' },
    { key: 'green',   label: 'V', title: 'Verde',     hex: '#22c55e' },
    { key: 'red',     label: 'V', title: 'Vermelho',  hex: '#ef4444' },
];

export default function ButtonsNode({ id, data }) {
    const buttonItems = data?.buttonItems || [
        { id: 'btn_0', text: 'Botão 1', color: 'default' },
        { id: 'btn_1', text: 'Botão 2', color: 'default' },
    ];
    const buttonDeleteAfterClick = Boolean(data?.buttonDeleteAfterClick);

    const updateItems = (updated) => data?.onChangeButtons?.(id, { buttonItems: updated });

    return (
        <div className="mt-2 space-y-2">
            <AutoGrowTextarea className="spt-textarea border-2"
                placeholder="Mensagem acima dos botões (opcional)"
                value={data?.text || ''}
                onChange={(e) => data?.onChangeText?.(id, e.target.value)} />

            <div className="space-y-1">
                {buttonItems.map((btn, index) => (
                    <div key={btn.id} className="space-y-1">
                        <div className="flex items-center gap-1 bg-black/30 border border-white/[0.06] rounded-md p-1.5">
                            <i className="fas fa-grip-vertical text-white/30 flex-shrink-0 text-[10px]" />
                            <input
                                className="flex-1 bg-transparent border-0 text-white text-xs p-1 focus:outline-none placeholder:text-white/20 min-w-0"
                                placeholder={`Texto do botão ${index + 1}`}
                                value={btn.text}
                                onChange={(e) => updateItems(buttonItems.map((b, i) => i === index ? { ...b, text: e.target.value } : b))} />
                            {buttonItems.length > 1 && (
                                <button type="button" className="p-0.5 rounded text-white/40 hover:text-red-500 flex-shrink-0"
                                    onClick={() => updateItems(buttonItems.filter((_, i) => i !== index))}>
                                    <i className="fas fa-times text-[10px]" />
                                </button>
                            )}
                        </div>
                        <div className="flex items-center gap-1 pl-4">
                            {BTN_COLORS.map(({ key, label, title, hex }) => {
                                const active = (btn.color || 'default') === key;
                                return (
                                    <button key={key} type="button" title={title}
                                        className="w-5 h-5 rounded-full text-[8px] font-bold flex items-center justify-center transition-all cursor-pointer"
                                        style={{ backgroundColor: active ? hex : 'transparent', border: `2px solid ${hex}`, color: active ? '#fff' : hex, opacity: active ? 1 : 0.5 }}
                                        onClick={() => updateItems(buttonItems.map((b, i) => i === index ? { ...b, color: key } : b))}>
                                        {label}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>

            {buttonItems.length < 6 && (
                <button type="button"
                    className="w-full flex items-center justify-center gap-1 py-1.5 rounded-md border border-dashed border-white/[0.08] text-white/40 hover:text-white hover:border-violet-500 transition-colors text-xs"
                    onClick={() => {
                        const newId = `btn_${Date.now()}`;
                        updateItems([...buttonItems, { id: newId, text: `Botão ${buttonItems.length + 1}`, color: 'default' }]);
                    }}>
                    <i className="fas fa-plus text-[10px] mr-1" />Adicionar botão
                </button>
            )}

            <label className="flex items-center gap-2 text-[10px] text-white/50 cursor-pointer pt-1">
                <input type="checkbox" className="h-3 w-3 rounded border-white/20 bg-white/10 accent-violet-500"
                    checked={buttonDeleteAfterClick}
                    onChange={(e) => data?.onChangeButtons?.(id, { buttonDeleteAfterClick: e.target.checked })} />
                <span>Sumir após clique</span>
            </label>
        </div>
    );
}
